import React from 'react';
import DualBanner from './DualBanner';

/**
 * 에디터용 DualBanner 컴포넌트 래퍼
 * 에디터에서 특별한 동작이 필요한 경우 이 컴포넌트를 사용
 */
const DualBannerEditor = (props) => {
  // 에디터 모드에서는 클릭 이벤트를 비활성화
  return <DualBanner {...props} isEditor={true} />;
};

export default DualBannerEditor;